import { Tag } from '../../models/interfaces/tag.interface';

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const now = new Date();

interface TagSeed {
  name: string;
  isActive?: boolean;
}

const tagSeeds: TagSeed[] = [
  { name: 'Tecnologia' },
  { name: 'IA' },
  { name: 'Gestão' },
  { name: 'Educação' },
  { name: 'Negócios' },
  { name: 'Liderança' },
  { name: 'Inovação' },
  { name: 'Comunicação' },
  { name: 'Produtividade' },
  { name: 'Carreira' },
  { name: 'Vendas' },
  { name: 'Marketing' },
  { name: 'Finanças', isActive: false },
  { name: 'Compliance' },
  { name: 'Bem-estar' },
];

function createTag(index: number, seed: TagSeed): Tag {
  const createdAt = new Date(now.getTime() - (tagSeeds.length - index) * DAY_IN_MS);
  const updatedAt = new Date(createdAt.getTime() + 2 * 60 * 60 * 1000);

  return {
    id: `tag-uuid-${index + 1}`,
    tenantId: 'tenant-uuid',
    name: seed.name.toLowerCase(),
    isActive: seed.isActive ?? true,
    createdAt,
    updatedAt,
  };
}

export const tagsMock: Tag[] = tagSeeds.map((seed, index) => createTag(index, seed));

export const tagMock: Tag = tagsMock[0];
